import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import React, { FC, ReactNode } from "react";
import { OtherSupportColumn } from "../../../../constants/types/acf";
import { Wrapper, Title, Description, Link, Content, Buttons } from "./styled";

type Props = OtherSupportColumn & { icon: ReactNode };

export const OtherSupportTile: FC<Props> = props => {
    return (
        <Wrapper>
            {props.icon}
            <Content>
                <Title>{props.title}</Title>
                <Description>{props.description}</Description>
                <Buttons>
                    {props.buttons.map(({ link }) => (
                        <Link
                            key={link.url}
                            {...link}
                            title={
                                <>
                                    {link.title} <OpenInNewIcon />
                                </>
                            }
                        />
                    ))}
                    {props.buttons.length == 1 ? (
                        <Link
                            hidden
                            title={
                                <>
                                    Hidden <OpenInNewIcon />
                                </>
                            }
                            url="//"
                            target=""
                        />
                    ) : null}
                </Buttons>
            </Content>
        </Wrapper>
    );
};
